import React from 'react';

const dashboardLinks = [
  {
    title: 'Hermes Dashboard — Public Funnel',
    description: 'Use this from any browser. If it fails, Funnel probably needs to be re-enabled on pop-os.',
    url: 'https://pop-os.tail8c6024.ts.net/',
    badge: 'Public Funnel',
    icon: '🧠',
  },
  {
    title: 'Hermes Dashboard — Tailnet Direct',
    description: 'Use this when your browser/device is connected to Z’s Tailscale tailnet.',
    url: 'http://100.66.187.66:9119/',
    badge: 'Tailnet',
    icon: '🔐',
  },
  {
    title: 'Hermes Dashboard — LAN Direct',
    description: 'Use this only on the same local network as pop-os. Bypasses Tailscale/Funnel DNS.',
    url: 'http://192.168.1.80:9119/',
    badge: 'LAN',
    icon: '🏠',
  },
  {
    title: 'Hermes Live Pages',
    description: 'Dokploy-hosted landing page for live artifacts and generated work pages.',
    url: 'http://hermes-live-559f07-178-156-128-52.sslip.io/',
    badge: 'Dokploy',
    icon: '📄',
  },
  {
    title: 'FIRMA Dokploy Project',
    description: 'Direct Dokploy project view for this FIRMA production environment.',
    url: 'http://178.156.128.52:3000/dashboard/project/eoLBmIfU47Fd7Uh63eW-a/environment/H0B_ToYnSTfHWZXaffBnH',
    badge: 'VPS',
    icon: '🚀',
  },
  {
    title: 'Dokploy Home',
    description: 'VPS deployment dashboard for all hosted services.',
    url: 'http://178.156.128.52:3000',
    badge: 'VPS',
    icon: '🖥️',
  },
  {
    title: 'FIRMA API',
    description: 'Backend API endpoint behind api.firma.zmcor.com.',
    url: 'https://api.firma.zmcor.com/',
    badge: 'API',
    icon: '🔌',
  },
  {
    title: 'Crypto Scalping Lab',
    description: 'Local/tailnet paper-trading dashboard. Requires Tailscale if not exposed publicly.',
    url: 'http://100.66.187.66:8787',
    badge: 'Tailnet',
    icon: '📈',
  },
];

function ExternalDashboards() {
  return (
    <div className="component-container dashboards-panel">
      <div className="component-header">
        <div>
          <h2>Operations Dashboards</h2>
          <p className="component-subtitle">
            One place to jump from FIRMA into Hermes, Dokploy, live pages, and related control surfaces.
          </p>
        </div>
      </div>

      <div className="dashboard-access-note">
        <strong>Hermes access fallback:</strong> Public Funnel works from any browser when enabled. Tailnet Direct needs Tailscale. LAN Direct only works on the same local network as pop-os.
      </div>

      <div className="dashboards-grid">
        {dashboardLinks.map((link) => (
          <a
            key={link.title}
            className="dashboard-card"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="dashboard-card-topline">
              <span className="dashboard-card-icon" aria-hidden="true">{link.icon}</span>
              <span className="dashboard-card-badge">{link.badge}</span>
            </div>
            <h3>{link.title}</h3>
            <p>{link.description}</p>
            <span className="dashboard-card-url">{link.url}</span>
          </a>
        ))}
      </div>

      <div className="component-footer">
        <p className="text-small">
          Security note: Hermes opens in a separate tab because it has its own login/session and should not be embedded.
        </p>
      </div>
    </div>
  );
}

export default ExternalDashboards;
